import { render, staticRenderFns } from "./SaleQuotationDetail.vue?vue&type=template&id=5e90e1cd&"
import script from "./SaleQuotationDetail.vue?vue&type=script&lang=js&"
export * from "./SaleQuotationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports